export default __webpack_public_path__ + "static/media/Tunic of Haloga.2ca07779.jpg";